import React from 'react';
import { Tabs, Tab, Card } from 'react-bootstrap';
import CategoryManager from './CategoryManager';
import { 
    USAGEPURPOSE_API, 
    EQUIPMENTTYPE_API, 
    EQUIPMENTSOURCE_API, 
    FUNDINGSOURCE_API, 
    QUALITYLEVEL_API, 
    CONNECTIONTYPE_API 
} from '@app/utils/apiUrl';

const AssetCategoryTabs = () => {
    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-12">
                    <Card className="shadow-sm">
                        <Card.Header className="bg-white py-3">
                            <h5 className="card-title fw-bold text-primary mb-0">
                                <i className="fas fa-list-alt mr-2" />
                                Quản lý danh mục bổ sung
                            </h5>
                        </Card.Header>
                        <Card.Body className="p-0">
                            <div className="category-tabs-wrapper">
                                <Tabs defaultActiveKey="usagePurpose" id="asset-category-tabs" className="custom-tabs border-bottom-0">
                                    <Tab eventKey="usagePurpose" title="Mục đích sử dụng">
                                        <CategoryManager 
                                            api={USAGEPURPOSE_API} 
                                            title="Mục đích sử dụng" 
                                            entityName="UsagePurpose"
                                            codeField="usagePurposeCode"
                                            nameField="usagePurposeName"
                                        />
                                    </Tab>
                                    <Tab eventKey="equipmentType" title="Loại trang bị">
                                        <CategoryManager 
                                            api={EQUIPMENTTYPE_API} 
                                            title="Loại trang bị" 
                                            entityName="EquipmentType"
                                            codeField="equipmentTypeCode"
                                            nameField="equipmentTypeName"
                                        />
                                    </Tab>
                                    <Tab eventKey="equipmentSource" title="Nguồn trang bị">
                                        <CategoryManager 
                                            api={EQUIPMENTSOURCE_API} 
                                            title="Nguồn trang bị" 
                                            entityName="EquipmentSource"
                                            codeField="equipmentSourceCode"
                                            nameField="equipmentSourceName"
                                        />
                                    </Tab>
                                    <Tab eventKey="fundingSource" title="Nguồn kinh phí">
                                        <CategoryManager 
                                            api={FUNDINGSOURCE_API} 
                                            title="Nguồn kinh phí" 
                                            entityName="FundingSource"
                                            codeField="fundingSourceCode"
                                            nameField="fundingSourceName"
                                        />
                                    </Tab>
                                    <Tab eventKey="qualityLevel" title="Cấp chất lượng">
                                        <CategoryManager 
                                            api={QUALITYLEVEL_API} 
                                            title="Cấp chất lượng" 
                                            entityName="QualityLevel"
                                            codeField="qualityLevelCode"
                                            nameField="qualityLevelName"
                                        />
                                    </Tab>
                                    <Tab eventKey="connectionType" title="Loại kết nối">
                                        <CategoryManager 
                                            api={CONNECTIONTYPE_API} 
                                            title="Loại kết nối" 
                                            entityName="ConnectionType"
                                            codeField="connectionTypeCode"
                                            nameField="connectionTypeName"
                                        />
                                    </Tab>
                                </Tabs>
                            </div>
                        </Card.Body>
                    </Card>
                </div>
            </div>
            
            <style jsx>{`
                .category-tabs-wrapper {
                    background: #fff;
                    padding: 0;
                    overflow: hidden;
                    border-top: 1px solid #dee2e6;
                }
                .custom-tabs {
                    display: flex;
                    flex-wrap: nowrap;
                    overflow-x: auto;
                    overflow-y: hidden;
                    white-space: nowrap;
                    -webkit-overflow-scrolling: touch;
                    padding: 0 10px;
                    background: #fff;
                    border-bottom: 1px solid #dee2e6 !important;
                    position: relative;
                    z-index: 2;
                    margin-bottom: 0 !important;
                }
                .custom-tabs::-webkit-scrollbar {
                    display: none;
                }
                .custom-tabs .nav-link {
                    color: #6c757d;
                    font-weight: 600;
                    border: none;
                    border-bottom: 3px solid transparent;
                    padding: 15px 20px;
                    text-transform: uppercase;
                    font-size: 0.85rem;
                    letter-spacing: 0.5px;
                    background: transparent;
                    transition: all 0.2s;
                }
                .custom-tabs .nav-link.active {
                    color: #007bff;
                    background: #fff !important;
                    border-bottom: 3px solid #007bff !important;
                }
                .custom-tabs .nav-link:hover {
                    color: #007bff;
                    background: #f8f9fa;
                }
                :global(.tab-content) {
                    background: #fff;
                    margin-top: 0 !important;
                    position: relative;
                    z-index: 1;
                }
                @media (max-width: 768px) {
                    .custom-tabs .nav-link {
                        padding: 12px 15px;
                        font-size: 0.8rem;
                    }
                }
            `}</style>
        </div>
    );
};

export default AssetCategoryTabs;
